import { Component, Input, OnChanges } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import * as _ from 'lodash';

import { BasePackagingComponent } from '../_base-packaging.component';


@Component({
  moduleId: module.id,
  selector: 'regulated-information',
  templateUrl: 'regulated-information.component.html',
  styleUrls: ['regulated-information.component.scss'],
})
export class RegulatedInformationComponent extends BasePackagingComponent implements OnChanges {

  @Input() declare itemDetailsData: any;

  @Input() declare data: any;

  @Input() formGroup: UntypedFormGroup;

  regulated: any;

  regulatedData: any;
  requiredData: Array<any>;

  textareaFields: Array<string> = [
    'description'
  ];
  fullSizeFields: Array<string> = [
    'description'
  ];
  quarteredSizeFields: Array<string> = [
    'unnaid_code'
  ];
  thirdSizeFields: Array<string> = [
    'shipping_name'
  ];

  ngOnChanges() {
    const data = this.separateData(this.data, ['regulated.regulated']);
    this.regulatedData = (<any>data)['true'][0];
    this.requiredData = (<any>data)['false'];
    this.regulated = this.formGroup.controls.regulated.value;
  }

  onRegulatedChange(selectedItem: any) {
    this.regulated = selectedItem.option;
    // if reguleated set to false, reset all invalid data within it
    // to avoid validation errors within pack
    if (selectedItem.option === 'N') {
      _.each(this.requiredData, (item: any) => {
        const control = this.formGroup.get(item.field_map);
        if (_.get(control, 'invalid')) { control.reset(); }
      });
    }
  }

  cellSize(item_name: string): string {
    if (this.hasField(item_name, this.fullSizeFields)) {
      return 'size-full';
    } else if (this.hasField(item_name, this.quarteredSizeFields)) {
      return 'size-quartered';
    } else if (this.hasField(item_name, this.thirdSizeFields)) {
      return 'size-three-quarters';
    } else {
      return 'size-half';
    }
  }

  isTextareaField(item_name: string): boolean {
    return this.hasField(item_name, this.textareaFields);
  }

  switchField(item: any): string {
    if (this.isTextareaField(item.item_name)) {
      return 'textarea';
    } else if (item.lookup !== null) {
      return 'select';
    } else {
      return 'input';
    }
  }

}
